module.exports = __webpack_public_path__ + "static/img/pic200-9.131bb75.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-9.jpeg
// module id = 7IKf
// module chunks = 34